import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { AlertService } from './alert.service';
import { BankService } from './bank.service';
import { UserService } from './user.service';
import { RoleService } from './role.service';
import { CustomerService } from './customer.service';
import { LoanProductService } from './loan.product.service';
import { LoanAccountService } from './loan.account.service';
import { ReportService } from './report.service';
import { GeneralLedgerService } from './general.ledger.service';
import { LoanInterestService } from './loan.interest.service';
import { MasterDataService, MasterData } from './master.data.service';
import { BatchService } from './batch.service';
import { AuthorisationService } from './authorisation.service';
import { LoanSchemeService } from './loan.scheme.service';
import { CustomerAccountService } from './customer.account.service';
import { CasaAccountService } from './casa.account.service';
import { CasaSchemeService } from './casa.scheme.service';
import { ShareSchemeService } from './share.scheme.service';
import { ShareAccountService } from './share.account.service';
import { JournalEntryService } from './journal.entry.service';
import { TermDepositSchemeService } from './term.deposit.scheme.service';
import { OverdraftSchemeService } from './overdraft.scheme.service';
import { TermDepositInterestService } from './term.deposit.interest.service';
import { OverdraftAccountService } from './overdraft.account.service';
import { LinkedCustomerService } from './linked.customer.service';
import { SMSSenderService } from './sms.sender.services';
import { ClearingSchemeService } from './clearing.scheme.service';
import { LoanRepaymentChequeService } from './loan.repayment.cheque.service';
import { ExternalBranchService } from './external.branch.service';
import { ClearingService } from './clearing.service';
import { TermDepositAccountService } from './term.deposit.account.service';
import { CommissionInterestService } from './commission.interest.service';
import { TdsRateService } from './tds.rate.service';
import { PigmySchemeService } from './pigmy.scheme.service';
import { PigmyAccountService } from './pigmy.account.service';
import { LienService } from './lien.service';
import { GeneralLedgerAccountService } from './general.ledger.account.service';
import { AppraiserService } from './appraiser.service';
import { RecurringDepositSchemeService } from './recurring.deposit.scheme.service';
import { RecurringDepositAccountService } from './recurring.deposit.account.service';
import { RecurringDepositInterestService } from './recurring.deposit.interest.service';
import { BranchService } from './branch.service';
import { CalendarEventService } from './calendar.event.service';
import { MicroFinanceCenterService } from './micro.finance.center.service';
import { BankNpaParameterService } from './bank.npa.parameter.service';
import { ProductLevelNpaService } from './product.level.npa.service';
import { CurrencyService } from './currency.service';
import { CurrencyExchangeRateService } from './currencyexchangerate.service';
import { MpesaService } from './mpesa.service';
import { AgmService } from './agm.service';
import { YearEndProcessService } from './year.end.process.service';
import { HolidayService } from './holiday.service';
import { CashierGlMaintenanceService } from './cashier.gl.maintenance.service';
import { ScreenService } from './screen.service';
import { RoleScreenService } from './roleScreen.service';
import { UploadService } from './upload.service';
import { ReportsMasterService } from './reportsMaster.service';
import { ReportDefinitionService } from './reportDefinition.service';
import { GroupService } from './group.service';
import { GlSubGroupService } from './glsubgroup.service';
import { ClassificationService } from './classification.service';
import { SubgroupService } from './subgroup.service';
import { QueryBuilderService } from './querybuilder.service';
import { BankTenantService } from './bank.tenant.service';
import { UserRoleScreenService } from './userRoleScreen.service';
import { InterfaceService } from './interface.service';
import { DashboardService } from './manegement.service';
import { SourceChannelService } from './source.channel.service';
import { ProductChargeService } from './product.charge.service';
import { CasaChargeService } from './casa.charge.service';
import { CustomerDashboardService } from './customer.dashboard.service';
import { EwalletService } from './ewallet.service';
import { SourceService } from './source.service';
import { TransactionTypeService } from './transactiontype.services';
import { TransactioncodewiseTransactionService } from './transactioncodewise.transaction.services';
import { ChargeService } from './charge.service';
import { AccountClassEwalletService } from './acountclass.ewallet.service';
import { InterfaceAccountClassChargeService } from './interface.accountclass.charges.service';
import { OrganizationBillingService } from './organization.service';
import { InvoiceService } from './invoice.service';
import { PaymentService } from './payment.service';
import { AccountTransactionService } from './account.transaction.service';
import { ChargesService } from './charges.service';
import { CollateralService } from './collateral.service';
import { EmployeeService } from './employee.service';
import { StandingInstructionService } from './standinginstruction.service';
import { DataSecurityService } from './data.security.service';
import { GroupLoanMicroFinanceService } from './group.loan.micro.finance.service';
import { ConsentTypeService } from './consent.type.service';
import { CustomerConsentService } from './customer.consent.service';
import { ChequebookService } from './chequebook.service';
import { ChequeStopService } from './chequestop.services';
import { CollateralLoanApplicationService } from './CollateralLoanApplication.service';
import { ChequeRevokeService } from './chequerevoke.services';
import { PasswordPolicyService } from './password.policy.service';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  exports: [
  ]
})
export class ServicesModule {
  static forRoot(): ModuleWithProviders<ServicesModule> {
    return {
      ngModule: ServicesModule,
      providers: [
        AlertService,
        UserService,
        RoleService,
        BankService,
        CustomerService,
        CustomerAccountService,
        LoanProductService,
        LoanAccountService,
        ReportService,
        GeneralLedgerService,
        CurrencyService,
        CurrencyExchangeRateService,
        LoanInterestService,
        MasterDataService,
        MasterData,
        BatchService,
        AuthorisationService,
        LoanSchemeService,
        CasaAccountService,
        CasaSchemeService,
        ShareSchemeService,
        ShareAccountService,
        JournalEntryService,
        TermDepositSchemeService,
        OverdraftSchemeService,
        TermDepositInterestService,
        OverdraftAccountService,
        LinkedCustomerService,
        SMSSenderService,
        ClearingSchemeService,
        LoanRepaymentChequeService,
        ExternalBranchService,
        ClearingService,
        TermDepositAccountService,
        CommissionInterestService,
        TdsRateService,
        PigmySchemeService,
        PigmyAccountService,
        LienService,
        GeneralLedgerAccountService,
        AppraiserService,
        RecurringDepositSchemeService,
        RecurringDepositInterestService,
        RecurringDepositAccountService,
        BranchService,
        CalendarEventService,
        MicroFinanceCenterService,
        BankNpaParameterService,
        ProductLevelNpaService,
        MpesaService,
        AgmService,
        YearEndProcessService,
        HolidayService,
        CashierGlMaintenanceService,
        ScreenService,
        RoleScreenService,
        UploadService,
        ReportsMasterService,
        ReportDefinitionService,
        GroupService,
        GlSubGroupService,
      ClassificationService,
      SubgroupService,
      QueryBuilderService,
      BankTenantService,
      UserRoleScreenService,
        InterfaceService,
      DashboardService,
      SourceChannelService,
        ProductChargeService,
        CasaChargeService,
    
        CustomerDashboardService,
        EwalletService,
        SourceService,
        TransactionTypeService,
        TransactioncodewiseTransactionService,
        ChargeService,
        AccountClassEwalletService,
        InterfaceAccountClassChargeService,
        OrganizationBillingService,
        InvoiceService,
        PaymentService,
        AccountTransactionService,
        ChargesService,
         StandingInstructionService,
        CollateralService,
         EmployeeService,
          DataSecurityService,
        GroupLoanMicroFinanceService,
          ConsentTypeService,
          CustomerConsentService,
          ChequebookService,
          ChequeStopService,
          CollateralLoanApplicationService,
          ChequeRevokeService,
          PasswordPolicyService
  
        
      

      ]
    };
  }

}
